import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { TextField, ThemeProvider } from "@mui/material";
import { FileUpload as FileUploadIcon } from "@mui/icons-material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment/moment";
import * as yup from "yup";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { BsImages } from "react-icons/bs";
import { useMutation } from "@tanstack/react-query";
import { postSubmitSIAOrSIPA } from "../../../services/authApi";
import { uploadImage } from "../../../services/userManagementApi";
import { RxCross1 } from "react-icons/rx";
import { theme } from "../../constants/muiTheme";
import ErrorPopup from "./ErrorPopup";
import { MdCancel } from "react-icons/md";
import { deleteImage } from "../../../services/InventoryAPI";

const validationSchema = yup.object({
  nomor: yup.string().required("nomor SIPA wajib diisi"),
  expired: yup.string().required("tanggal kadaluarsa wajib di isi"),
  file: yup.mixed().required("file wajib diisi"),
});

const toDate = moment().format("YYYY-MM-DD");
const toDateApi = (date) => moment(date).format("YYYY-MM-DD");

const ModalSIPA = (props) => {
  const { open, setOpen, sipaFile, onSuccessFunc } = props;

  const [errorMessage, setErrorMessage] = useState("");

  const { mutate: mutateSubmitSIAOrSIPA } = useMutation({
    mutationFn: postSubmitSIAOrSIPA,
    onSuccess: () => {
      if (onSuccessFunc) onSuccessFunc();
      setOpen(false);
    },
    onError: (err) => {
      setErrorMessage(err.message.id ? err.message.id : err.message);
    },
  });

  const { mutate: mutateUploadImage } = useMutation({
    mutationFn: uploadImage,
    onSuccess: (data) => {
      formik.setFieldValue("file", data.url);
    },
  });

  const { mutate: mutateDeleteImage } = useMutation({
    mutationFn: deleteImage,
    onSuccess: () => formik.setFieldValue("file", ""),
    onError: (err) =>
      setErrorMessage(err.message.id ? err.message.id : err.message),
  });

  const formik = useFormik({
    initialValues: {
      nomor: "",
      expired: toDate,
      file: "",
    },
    validationSchema,
    validateOnMount: true,
    onSubmit: (value) => {
      mutateSubmitSIAOrSIPA({
        ...value,
        type: "sipa",
      });
    },
  });

  const handleUploadImage = (e) => {
    mutateUploadImage(e.target.files[0]);
  };

  useEffect(() => {
    formik.setFieldValue("file", sipaFile ? sipaFile : "");
  }, [open]);

  return (
    <ThemeProvider theme={theme}>
      <>
        {open ? (
          <form onSubmit={formik.handleSubmit}>
            <div className="justify-center items-center flex overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none text-[12px]">
              <div className="relative w-auto my-6 mx-auto max-w-3xl">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="px-8 pt-8 mb-4 flex justify-between items-center gap-4">
                    <div>
                      <p className="text-[#68A1F9] text-[18px] font-semibold">
                        Perbarui SIPA
                      </p>
                      <p>
                        Upload Surat Izin Praktik Apoteker dengan masa berlaku
                        yang baru
                      </p>
                    </div>
                    <RxCross1
                      className="text-[16px] cursor-pointer text-red-500 hover:text-gray-300"
                      onClick={() => setOpen(false)}
                    />
                  </div>

                  <div className="flex justify-center flex-column px-8">
                    <TextField
                      fullWidth
                      label="No SIPA"
                      sx={{ marginBottom: 2 }}
                      onChange={(e) =>
                        formik.setFieldValue("nomor", e.target.value)
                      }
                    />
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DesktopDatePicker
                        views={["year", "month", "day"]}
                        fullWidth
                        onChange={(newExpiredDate) =>
                          formik.setFieldValue(
                            "expired",
                            toDateApi(newExpiredDate)
                          )
                        }
                        value={formik.values.expired}
                        renderInput={(params) => {
                          return <TextField {...params} />;
                        }}
                        disablePast
                        label="SIPA Expired"
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="input-foto mb-4 px-8">
                    <div className="bg-blue-500 py-2 px-4 text-white font-medium flex mt-4 items-center gap-3 text-[14px] rounded-t-lg">
                      <span>
                        <BsImages />
                      </span>
                      Surat Izin Praktik Apoteker
                    </div>

                    <div className="flex items-center justify-center h-25% border-t-0 border-2 border-solid rounded-b-lg p-3">
                      {formik.values.file !== "" ? (
                        <label
                          htmlFor="drop"
                          className="cursor-pointer flex flex-col items-center justify-center w-[30%]"
                        >
                          <div className="relative">
                            <img
                              src={formik.values.file}
                              alt="foto produk SIPA"
                              className="h-[20%]"
                            />
                            <MdCancel
                              className="text-red-500 hover:text-gray-300 absolute -right-2 -top-2 text-[24px] bg-white rounded-full"
                              onClick={() =>
                                mutateDeleteImage(formik.values.file)
                              }
                            />
                          </div>
                          <input
                            id="drop"
                            type="file"
                            hidden
                            accept="accept='image/jpeg,image/png,image/jpg"
                            onChange={(e) => handleUploadImage(e)}
                          />
                        </label>
                      ) : (
                        <label
                          htmlFor="dropzone-file1"
                          className="cursor-pointer flex flex-col items-center justify-center w-[100%] p-6"
                        >
                          <input
                            id="dropzone-file1"
                            hidden
                            type="file"
                            accept="image/jpeg, image/png, image/jpg"
                            onChange={(e) => handleUploadImage(e)}
                          />
                          <div className="flex justify-center items-center flex-col text-center">
                            <FileUploadIcon sx={{ textAlign: "center" }} />
                            <p>Unggah SIA terbaru</p>
                          </div>
                        </label>
                      )}
                    </div>
                  </div>
                  {/*footer*/}
                  <div className="flex font-semibold w-full justify-center px-8 pb-8">
                    <button
                      className="text-[#344054] border border-black p-2 rounded-md w-full hover:bg-gray-300"
                      onClick={() => setOpen(false)}
                    >
                      Batal
                    </button>
                    <button
                      className="text-white bg-[#007AF1] p-2 rounded-md ml-2 w-full hover:bg-gray-300 disabled:bg-gray-300"
                      type="submit"
                      disabled={!formik.isValid}
                    >
                      Ubah
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="opacity-25 fixed inset-0 z-40 bg-black"></div> */}
          </form>
        ) : null}
      </>

      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </ThemeProvider>
  );
};

export default ModalSIPA;
